module.exports = "img/flags/MH.bb4b9d4.png";